import api, { checkTokenErrorResponse } from '..';

const billTypes = [
    [0, "Pagar"],
    [1, "Receber"],
]

export async function getBills(filterFields = {}) {
    const params = {}
    console.log("Filtro", filterFields)
    Object.keys(filterFields).forEach(key => {
        if(key === "tipo") {
            params[key] = billTypes.find(type => type[1] === filterFields[key])[0];
        }
        else if(filterFields[key] != "") {
            params[key] = filterFields[key];
        }
    })
    return api.get("contas/", {params})
        .then(function (response) {
            // handle success
            return response;
        })
        .catch(function (error) {
            // handle error
            console.log(error);
            if (error.response) {
                console.log(error.response.data);
                checkTokenErrorResponse(error.response);
            }
            return error;
        });
};

export async function getInfoNewBill() {
    return api.get("contas/informacoes_nova_conta/")
        .then(function (response) {
            // handle success
            return response;
        })
        .catch(function (error) {
            // handle error
            console.log(error);
            if (error.response) {
                console.log(error.response.data);
                checkTokenErrorResponse(error.response);
            }
            return error;
        });
};

export async function postBill(empresa, colaborador,centro_de_custo, plano_de_contas, parceiro, descricao, moeda, numero_parcelas, parcelas = [], forma_de_pagamento, conta_bancaria, obs, tipo, produtos = [], situacao = false, xml, identificadorNota) {
    const formdata = new FormData();
    formdata.append("empresa",empresa)
    if(centro_de_custo)
        formdata.append("centro_de_custo",centro_de_custo)
    if(plano_de_contas)
        formdata.append("plano_de_contas",plano_de_contas)
    formdata.append("parceiro",parceiro)
    formdata.append("descricao",descricao)
    formdata.append("moeda",moeda)
    formdata.append("numero_parcelas",numero_parcelas)
    formdata.append("forma_de_pagamento",forma_de_pagamento)
    formdata.append("obs",obs)
    formdata.append("tipo",tipo)
    formdata.append("situacao",situacao ? 'true' : false)
    formdata.append("parcelas",JSON.stringify(parcelas))
    formdata.append("produtos",JSON.stringify(produtos))
    if(xml)
        formdata.append("xml",xml)
    if(conta_bancaria)
        formdata.append("conta_bancaria",conta_bancaria)
    if(colaborador)
        formdata.append("colaborador",colaborador)

    formdata.append("identificadorNota", identificadorNota);

    let paga = true;
    let numero_parcelas_pagas = 0

    for (const parcela of parcelas) {
        if(parcela.paga == false) {
            paga = false;
        }
        else {
            numero_parcelas_pagas++;
        }
    }

    formdata.append("paga",paga ? "true" : "false")
    formdata.append("numero_parcelas_pagas",numero_parcelas_pagas)

    return api.post(`contas/`, formdata)
        .then(function (response) {
            // handle success
            return response;
        })
        .catch(function (error) {
            // handle error
            console.log(error);
            if (error.response) {
                console.log(error.response.data);
                checkTokenErrorResponse(error.response);
            }
            return error;
        });
};


export async function getBill(id) {
    return api.get(`contas/${id}/`)
        .then(function (response) {
            // handle success
            return response;
        })
        .catch(function (error) {
            // handle error
            console.log(error);
            if (error.response) {
                console.log(error.response.data);
                checkTokenErrorResponse(error.response);
            }
            return error;
        });
};

export async function deleteBill(id) {
    return api.delete(`contas/${id}/`)
        .then(function (response) {
            // handle success
            return response;
        })
        .catch(function (error) {
            // handle error
            console.log(error);
            if (error.response) {
                console.log(error.response.data);
                checkTokenErrorResponse(error.response);
            }
            return error;
        });
};

export async function pathcBill(id, empresa, colaborador,centro_de_custo, plano_de_contas, parceiro, descricao, moeda, numero_parcelas, parcelas = [], forma_de_pagamento, conta_bancaria, obs, identificadorNota,situacao = false) {
    const data = {
        empresa,
        parceiro,
        descricao,
        moeda,
        numero_parcelas,
        forma_de_pagamento,
        obs,
        situacao,
        parcelas,
        identificadorNota
    };
    if(centro_de_custo)
        data["centro_de_custo"] = centro_de_custo;
    if(plano_de_contas)
        data["plano_de_contas"] = plano_de_contas;
    if(conta_bancaria)
        data.conta_bancaria = conta_bancaria
    else
        data.conta_bancaria = null
    if(colaborador)
        data.colaborador = colaborador
    else
        data.colaborador = null

    return api.patch(`contas/${id}/`, data)
        .then(function (response) {
            // handle success
            return response;
        })
        .catch(function (error) {
            // handle error
            console.log(error);
            if (error.response) {
                console.log(error.response.data);
                checkTokenErrorResponse(error.response);
            }
            return error;
        });
};


export async function postBillPayment(id, idParcela, data_pag, valor_pago) {
    const formdata = new FormData();

    formdata.append("data_pag", data_pag);
    formdata.append("valor_pago", valor_pago);

    return api.post(`contas/${id}/registrar_pagamento/${idParcela}/`, formdata)
        .then(function (response) {
            // handle success
            return response;
        })
        .catch(function (error) {
            // handle error
            console.log(error);
            if (error.response) {
                console.log(error.response.data);
                checkTokenErrorResponse(error.response);
            }
            return error;
        });
};

export async function postXml(xml) {
    const formdata = new FormData();

    formdata.append("xml", xml);

    return api.post(`contas/xml/`, formdata)
        .then(function (response) {
            // handle success
            return response;
        })
        .catch(function (error) {
            // handle error
            console.log(error);
            if (error.response) {
                console.log(error.response.data);
                checkTokenErrorResponse(error.response);
            }
            return error;
        });
};


const billServices = {
    getBill,
    getInfoNewBill,
    getBills,
    postBill,
    deleteBill,
    pathcBill,
    postBillPayment,
    postXml,
    billTypes,
}
export default billServices;